<div class="top-back">
  <div class="top-back__left">
    <i (click)="backToPreviousPage()" class="icon-arrow"></i>
    <button (click)="backToPreviousPage()" class="btn small simple">
      <span class="text-gradient">{{'btn.back' | translate }}</span>
    </button>
  </div>
  <div class="top-back__center">
    <h1 class="top-back__center--title" id="sign-up-title">
      {{title() | translate}}
    </h1>
  </div>
  <div class="top-back__right"></div>
</div>
